export const REPORTS_NAMESPACE = 'jbp-reports'

export const TRANSLATION_KEYS = {
  localEntitiesSwitch: `${REPORTS_NAMESPACE}-local-entities-switch`,
  globalEntitiesSwitch: `${REPORTS_NAMESPACE}-global-entities-switch`,
  predefineFilters: `${REPORTS_NAMESPACE}-predefine-filters`,
  filters: {
    title: `${REPORTS_NAMESPACE}--filters-partner-types`,
    normalPartners: `${REPORTS_NAMESPACE}--filters-normal-partners`,
    amplifyTrack: `${REPORTS_NAMESPACE}--filters-amplify-track`,
    filtersLabel: `${REPORTS_NAMESPACE}--filters-filters-label`,
    filtersClear: `${REPORTS_NAMESPACE}--filters-filters-clear`,
    specs: `${REPORTS_NAMESPACE}--filters-partner-specs`,
  },
  table: {
    openPartnerPlan: `${REPORTS_NAMESPACE}--table-open-partner-plan`,
  },
}
